"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import _ from "lodash";
import API from "@ym-framework/api-utils";
let OpenIconConfig = class extends Vue {
  constructor() {
    super(...arguments);
    this.OpenIconMode = "shop_name";
    this.imgBase64 = "";
    this.hasFile = true;
    this.changeIconMode = _.debounce((data) => __async(this, null, function* () {
      yield API.put(`api://base.local/storages/preference/iconMode`, {
        iconMode: data
      });
    }), 500);
  }
  mounted() {
    return __async(this, null, function* () {
      yield this.initIconMode();
    });
  }
  initIconMode() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.local/storages/preference/iconMode`
        );
        this.OpenIconMode = response.data.value.iconMode;
        if (this.OpenIconMode === "upload_icon") {
          this.getUploadIcon();
        }
      } catch (error) {
        yield API.put(`api://base.local/storages/preference/iconMode`, {
          iconMode: "shop_name"
        });
      }
    });
  }
  getUploadIcon() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          `api://base.local/storages/preference/icon`
        );
        const data = this.convertToBase64(response.data.value.icon);
        this.imgBase64 = response.data.value.iconHeader + "," + data;
        this.hasFile = false;
      } catch (error) {
        this.hasFile = true;
      }
    });
  }
  beforeUpload(file) {
  }
  handleIOutRemove() {
    return __async(this, null, function* () {
      try {
        yield API.delete(`api://base.local/storages/preference/icon`);
        this.imgBase64 = "";
        this.hasFile = true;
      } catch (error) {
      }
    });
  }
  handleRemove(file) {
    return __async(this, null, function* () {
      try {
        this._iconUploader.clearFiles();
        yield API.delete(`api://base.local/storages/preference/icon`);
        this.imgBase64 = "";
      } catch (error) {
      }
    });
  }
  handleChange(file, fileList) {
    return __async(this, null, function* () {
      let that = this;
      this.hasFile = true;
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error(this.$t("open-icon-config.upload_icon_size_error"));
        this._iconUploader.clearFiles();
        return;
      }
      const reader = new FileReader();
      reader.onloadend = function(e) {
        const base64String = reader.result.split(",")[1];
        const header = reader.result.split(",")[0];
        that.imgBase64 = reader.result;
        that.uploadIcon(header, that.convertToBase64Url(base64String));
      };
      reader.readAsDataURL(file.raw);
    });
  }
  uploadIcon(iconHeader, dataUrl) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.local/storages/preference/icon`, {
          icon: dataUrl,
          iconHeader
        });
      } catch (error) {
        this.$message.error(
          this.$t("open-icon-config.upload_icon_error")
        );
      }
    });
  }
  handlePreview() {
  }
  convertToBase64Url(base64String) {
    return base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }
  convertToBase64(base64Url) {
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    while (base64.length % 4 !== 0) {
      base64 += "=";
    }
    return base64;
  }
};
__decorateClass([
  Ref("iconUploader")
], OpenIconConfig.prototype, "_iconUploader", 2);
OpenIconConfig = __decorateClass([
  Component
], OpenIconConfig);
export {
  OpenIconConfig as default
};
